import { Injectable } from "@angular/core";
import { Observable, catchError } from "rxjs";
import { environment } from "src/environments/environment";
import { AppTokenService } from "./app-token.service";
import { HttpHandlerService } from "./http-handler.service";

@Injectable({
    providedIn: 'root'
})
export class FileHandlerService {

    _httpHandler: HttpHandlerService;
    _apiUrl = environment.apiUrl;

    _resourceEndPoint = 'file';
    _signedURLUploadEndPoint = '/upload/getSignedUrl';
    _signedURLDownloadEndPoint = '/download/getSignedUrl';
    _uploadCompleteEndPoint = '/upload/complete';

    constructor(private httpHandler: HttpHandlerService, private appTokenService: AppTokenService) {
        this._httpHandler = httpHandler;
    }

    public GetSignedURLForUpload(requestObj): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}${this._signedURLUploadEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            requestObj
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public GetSignedURLForDownload(requestObj): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}${this._signedURLDownloadEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            requestObj
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public UploadFile(signedURL: string, file: any, headers = null): Observable<any> {
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            signedURL,
            file, null, null, headers
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse, true);
    }

    public UploadComplete(requestObj): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}${this._uploadCompleteEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            requestObj
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public GetFileUrlById(id: number): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}/${id}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }
};